export const booking_order_types = ['appointments', 'events'];
